import api from './apiClient';

export const venuesAPI = {
  async getAll() {
    try {
      const response = await api.get('/venues');
      return response.data || response;
    } catch (error) {
      console.error('Backend venues API error:', error);
      throw error;
    }
  },

  async getById(venueId) {
    try {
      const response = await api.get(`/venues/${venueId}`);
      return response.data || response;
    } catch (error) {
      console.error('Backend get venue API error:', error);
      throw error;
    }
  },

  async getByCity(cityName) {
    try {
      const response = await api.get('/venues/by-city', { params: { cityName } });
      return response.data || response;
    } catch (error) {
      console.error('Backend get venues by city API error:', error);
      throw error;
    }
  },

  async create(venueData) {
    try {
      const response = await api.post('/venues', venueData);
      return response.data || response;
    } catch (error) {
      console.error('Backend create venue API error:', error);
      throw error;
    }
  },

  async createWithPlaceId(venueData, placeId) {
    try {
      const response = await api.post('/venues/with-place-id', venueData, {
        params: { placeId },
      });
      return response.data || response;
    } catch (error) {
      console.error('Backend create venue with place ID API error:', error);
      throw error;
    }
  },

  async createWithLocation(venueData, cityName, countryName) {
    try {
      const response = await api.post('/venues/with-location', venueData, {
        params: { cityName, countryName },
      });
      return response.data || response;
    } catch (error) {
      console.error('Backend create venue with location API error:', error);
      throw error;
    }
  },

  async update(venueId, venueData) {
    try {
      const response = await api.put(`/venues/${venueId}`, venueData);
      return response.data || response;
    } catch (error) {
      console.error('Backend update venue API error:', error);
      throw error;
    }
  },

  async delete(venueId) {
    try {
      const response = await api.delete(`/venues/${venueId}`);
      return response.data || response;
    } catch (error) {
      console.error('Backend delete venue API error:', error);
      throw error;
    }
  },

  async getVenueStats(venueId) {
    try {
      const response = await api.get(`/venues/${venueId}/stats`);
      return response.data || response;
    } catch (error) {
      console.error('Backend venue stats API error:', error);
      throw error;
    }
  },

  async getVenueEvents(venueId) {
    try {
      const response = await api.get(`/venues/${venueId}/events`);
      return response.data || response;
    } catch (error) {
      console.error('Backend venue events API error:', error);
      throw error;
    }
  },
};

export default venuesAPI;

